import { initializeConsolFilters } from './lib/console-filters';

// Initialize console filters first to suppress known WebContainer warnings
initializeConsolFilters();

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { TimeTrackingProvider } from './context/TimeTrackingContext';
// Kanban tokens are now merged into index.css

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <TimeTrackingProvider>
      <App />
    </TimeTrackingProvider>
  </StrictMode>
);
